import { LinkItem } from '../../../../design-system';
import { routeCreator } from '../../routeCreator';

export const getBreadcrumbLinks = (name: string | undefined): LinkItem[] => [
  { to: routeCreator.list(), label: 'Surveys' },
  { key: routeCreator.details(name || 'id'), label: name || 'Loading...' },
];
